import { render, staticRenderFns } from "./TableNumber.vue?vue&type=template&id=222218ae"
import script from "./TableNumber.vue?vue&type=script&lang=ts"
export * from "./TableNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports